<template>
  <!-- Hbase查询 -->
  <div class="hbase">
    <div ref="condition" class="condition">
      <el-form
        :inline="true"
        :model="formInline"
        :rules="rules"
        label-width="80px"
      >
        <el-form-item label="表名" prop="tableName">
          <el-select v-model="formInline.tableName" placeholder="请选择">
            <el-option
              v-for="(tableName, index) in tableNames"
              :key="index"
              :label="tableName"
              :value="tableName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="平台名称" prop="platformName">
          <el-select v-model="formInline.platformIndex" placeholder="请选择">
            <el-option
              v-for="(item, index) in platformNames"
              :key="index"
              :label="item.tableName"
              :value="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期" prop="date">
          <el-date-picker
            v-model="formInline.date"
            align="right"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="数量" prop="count">
          <el-input v-model="formInline.count"></el-input>
        </el-form-item>
        <el-form-item label="skuid" prop="skuid">
          <el-input v-model="formInline.skuid"></el-input>
        </el-form-item>
        <el-form-item label="评论ID" prop="commentId">
          <el-input v-model="formInline.commentId"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            :disabled="querying"
            type="primary"
            :loading="querying"
            @click="onSubmit"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <el-form :model="formInline" :rules="rules" label-width="80px">
        <el-form-item label="字段名" prop="fieldName">
          <el-input v-model="formInline.fieldName"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="result-table-container">
      <el-table
        class="result-table"
        ref="table"
        :data="tableData"
        border
        :height="tableHeight"
        stripe
      >
        <el-table-column label="rawData" :width="rawDataWidth" :fixed="true">
          <template slot-scope="scope">
            <el-input type="textarea" :rows="5" :value="scope.row.rawData">
            </el-input>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(column, index) in columnsData"
          :key="index"
          :prop="column.prop"
          :label="column.label"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
// import axios from "axios";

function PrefixZero(num, n) {
  return (Array(n).join("0") + num).slice(-n);
}

export default {
  data() {
    return {
      formInline: {
        tableName: "",
        platformIndex: 0,
        date: new Date(),
        fieldName: "",
        count: 0,
        skuid: "",
        commentId: ""
      },
      rules: {
        tableName: [{ required: true, message: "请选择表名", trigger: "blur" }],
        platformName: [
          { required: true, message: "请选择平台名称", trigger: "blur" }
        ],
        date: [{ required: true, message: "请选择日期", trigger: "blur" }]
      },
      tableNames: [],
      platformNames: [],
      tableData: [],
      columnsData: [],
      querying: false,
      tableHeight: null,
      rawDataWidth: null
    };
  },
  computed: {
    // rawDataWidth: {
    //   get() {
    //     return String(
    //       this.$refs.table && this.tableData.length > 0
    //         ? this.$refs.table.$el.getBoundingClientRect().width
    //         : 500
    //     );
    //   },
    // },
  },
  methods: {
    onSubmit() {
      this.querying = true;
      const reqData = {
        tableName: this.formInline.tableName,
        date: `${this.formInline.date.getFullYear()}-${PrefixZero(
          this.formInline.date.getMonth() + 1,
          2
        )}-${PrefixZero(this.formInline.date.getDate(), 2)}`,
        colums: this.formInline.fieldName,
        count: this.formInline.count,
        siteId: this.platformNames[this.formInline.platformIndex].siteId,
        platformId: this.platformNames[this.formInline.platformIndex]
          .platformId,
        skuId: this.formInline.skuid,
        commentId: this.formInline.commentId
      };
      Object.keys(reqData).forEach(key => {
        if (!reqData[key]) delete reqData[key];
      });
      this.$http({
        url: this.$api.get_result,
        params: reqData,
        method: "get"
      })
        .then(data => {
          this.querying = false;
          if (Array.isArray(data)) {
            const columnskeys = {};
            this.tableData = data.map(item => {
              Object.keys(item).forEach(value => (columnskeys[value] = 1));
              return Object.assign(
                {
                  rawData: JSON.stringify(item)
                },
                item
              );
            });
            this.columnsData = Object.keys(columnskeys).map(column => {
              return {
                prop: column,
                label: column
              };
            });
            this.$message.success("查询成功");
          } else {
            this.$message.error("查询失败，请重试");
          }
        })
        .catch(reason => {
          this.$message.error("查询失败，原因" + JSON.stringify(reason));
        });
    },
    onWindowResize() {
      if (this.$el && this.$refs.condition)
        this.tableHeight =
          this.$el.clientHeight - this.$refs.condition.offsetHeight - 60;
      if (this.$refs.table && this.tableData.length > 0) {
        this.rawDataWidth = this.$refs.table.$el.clientWidth;
      } else {
        this.rawDataWidth = 500;
      }
    }
  },
  created() {
    this.$http({ url: this.$api.get_table }).then(data => {
      if ("0" === data.code && true === data.success) {
        this.tableNames = data.data;
      }
    });
    this.$http({ url: this.$api.get_platform }).then(data => {
      if ("0" === data.code && true === data.success) {
        this.platformNames = data.data;
      }
    });
  },
  mounted() {
    this.onWindowResize();
    window.addEventListener("resize", this.onWindowResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onWindowResize);
  }
};
</script>

<style lang="less" scoped>
.hbase {
  box-sizing: border-box;
  padding: 20px;
  width: 100%;
  height: 100%;
}
.condition {
  //height: 25%;
  //overflow-y: auto;
}
.result-table {
  width: 100%;

  &-container {
    width: 100%;
    height: 75%;
  }

  /deep/ .el-table--scrollable-x .el-table__body-wrapper {
    overflow: auto !important;
  }
  /deep/.el-table__fixed-right-patch {
    background-color: #f5f7fa !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/identify/views/HbaseSearch.vue